import * as yup from "yup";
import type { TaxIdType } from "~/graphql/supergraphTypes";

const TAX_ID_LABELS: Record<string, string> = {
  ein: "EIN",
  ssn: "SSN",
  itin: "ITIN",
};

export const getTaxIdLabel = (taxIdType?: string | null): string =>
  (taxIdType && TAX_ID_LABELS[taxIdType]) || "identification number";

export type ScheduleCheck = (
  value: string,
  taxIdType: string | null,
  arenaAccessId: number,
) => void;

const readTaxIdType = (parent: unknown): string | null => {
  if (typeof parent !== "object" || parent === null || !("taxIdType" in parent)) {
    return null;
  }
  return typeof parent.taxIdType === "string" ? parent.taxIdType : null;
};

export const withExistingProfileTaxIdCheck = (
  schema: yup.StringSchema,
  {
    arenaAccessId,
    taxIdType,
    scheduleCheck,
  }: { arenaAccessId?: number; taxIdType?: TaxIdType; scheduleCheck: ScheduleCheck },
): yup.StringSchema => {
  if (arenaAccessId == null) {
    return schema;
  }
  return schema.test("existing-root-investing-profile", "", function (value) {
    const enteredType = taxIdType ?? readTaxIdType(this.parent);
    scheduleCheck(value ?? "", enteredType, arenaAccessId);
    return true;
  });
};
